<lib-ninja-statistics-content></lib-ninja-statistics-content>
